<div class="interface-control__user-settings-ccy-pair-field__container">
  <bfx-autoComplete
    #inputField
    [(ngModel)]="data.ccyPairModel"
    [label]="data.label | capitalize:true"
    [suggestions]="data.filteredItems"
    (completeMethod)="autocompleteSearch($event)"
    [disabled]="data.disabled || locked"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    (onSelect)="onSelect($event)"
    dataKey="dataItem"
    field="label"
    autoHighlight="true"
    appendTo="body"
    nativeDesktopDropdown="bfxCcyPair"
    target="bfxCcyPair"
    delay="4"
    [skipSorting]="true"
    [skipBlur]="true"
    [state]="data.state"
    [dropdown]="true"
    [style]="{'width':'100%'}"
    [minLength]="1"
    size="sm"
    [maxlength]="6"
    [fieldSuffix]="data.inverted ? '<sup>1</sup>/<sub>n</sub>' : ''"
  >
  </bfx-autoComplete>
</div>
